/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Invitecollaboratoraddrole3Inputs */

const en_settings_collaborators_invitecollaboratoraddrole3 = /** @type {(inputs: Settings_Collaborators_Invitecollaboratoraddrole3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Role`)
};

/**
* | output |
* | --- |
* | "Add Role" |
*
* @param {Settings_Collaborators_Invitecollaboratoraddrole3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_invitecollaboratoraddrole3 = /** @type {((inputs?: Settings_Collaborators_Invitecollaboratoraddrole3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Invitecollaboratoraddrole3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_invitecollaboratoraddrole3(inputs)
});
export { settings_collaborators_invitecollaboratoraddrole3 as "settings_collaborators_inviteCollaboratorAddRole" }